<template>
	<div>
		<div>
			{{ label }}
		</div>
		<label class="switch">
			<input v-on="inputListeners" :checked="value" type="checkbox" />
			<div class="slider round"></div>
		</label>
	</div>
</template>
<script>
export default {
	props: {
		label: {
			type: String,
			default: ''
		},
		value: null
	},
	computed: {
		inputListeners() {
			const vm = this;

			return {
				...this.$listeners,
				input(event) {
					vm.$emit('input', event.target.checked);
					vm.$emit('setCheckboxVal', event.target.checked);
				},
				focus(event) {
					vm.$emit('focus', event.target.id);
				},
				blur(event) {
					vm.$emit('blur', event.target.id);
				}
			};
		}
	}
};
</script>
<style lang="scss" scoped>
@import "@/assets/colors.scss";
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
  margin-top: 6px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: $info;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
